import { render, staticRenderFns } from "./StoresTable.vue?vue&type=template&id=32c1f990&"
import script from "./StoresTable.vue?vue&type=script&lang=js&"
export * from "./StoresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports